/**
 * @generated SignedSource<<44bab8bc0abf53c2f7522e45ae9c55c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type TxnSortEnum = "ACCOUNT" | "AMOUNT" | "CATEGORY" | "COUNTERPARTY" | "DATE" | "DESCRIPTION" | "NATURE" | "%future added value";
export type revenueCellPanel_Query$variables = {
  accountId?: string | null | undefined;
  from?: string | null | undefined;
  month?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  sort?: TxnSortEnum | null | undefined;
  sortDirection?: string | null | undefined;
  to?: string | null | undefined;
};
export type revenueCellPanel_Query$data = {
  readonly transactions: {
    readonly limit: number;
    readonly totalAmount: number;
    readonly totalCount: number;
    readonly txns: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly category: string | null | undefined;
      readonly classification: TxnClassificationEnum | null | undefined;
      readonly counterparty: {
        readonly name: string;
      } | null | undefined;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly internal: boolean;
      readonly kind: string;
      readonly md5: string;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
  };
};
export type revenueCellPanel_Query = {
  response: revenueCellPanel_Query$data;
  variables: revenueCellPanel_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v7 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  },
  {
    "kind": "Literal",
    "name": "excludeDistributions",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "flow",
    "value": "REVENUE"
  },
  {
    "kind": "Variable",
    "name": "from",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  },
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  {
    "kind": "Variable",
    "name": "sortDirection",
    "variableName": "sortDirection"
  },
  {
    "kind": "Variable",
    "name": "to",
    "variableName": "to"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalAmount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limit",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "md5",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internal",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "revenueCellPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v21/*: any*/)
                ],
                "storageKey": null
              },
              (v23/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "revenueCellPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v23/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "39b339f1e6c89481f1396bcc7cc38afc",
    "id": null,
    "metadata": {},
    "name": "revenueCellPanel_Query",
    "operationKind": "query",
    "text": "query revenueCellPanel_Query(\n  $accountId: ID\n  $month: String\n  $from: String\n  $to: String\n  $perspectiveId: ID\n  $sort: TxnSortEnum\n  $sortDirection: String\n) {\n  transactions(flow: REVENUE, excludeDistributions: true, accountId: $accountId, month: $month, from: $from, to: $to, perspectiveId: $perspectiveId, sort: $sort, sortDirection: $sortDirection) {\n    totalCount\n    totalAmount\n    limit\n    txns {\n      txn {\n        id\n      }\n      md5\n      postingDate\n      description\n      amount\n      kind\n      accountNumber\n      internal\n      classification\n      expenseNature {\n        id\n        name\n      }\n      counterparty {\n        name\n        id\n      }\n      category\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d82f476e3fb788e10538c1227fc778be";

export default node;
